module.exports = __webpack_public_path__ + "img/logout-o.1ad7b338.svg";